import React from "react"
import { Link } from 'gatsby'

import envelopeIcon from "../images/envelope.svg"
import facebookIcon from "../images/facebook-circle.svg"
import instagramIcon from "../images/instagram-circle.svg"
import linkedinIcon from "../images/linkedin-circle.svg"
import logoBlue from "../images/logo-blue.svg"
import mapPin from "../images/map-pin.svg"
import ringingPhoneIcon from "../images/ringing-phone.svg"
import twitterIcon from "../images/twitter-circle.svg"

import './footer.scss'

const Footer = ({ children }) => (
  <footer className='FooterStyling bg-white mx-auto'>
    <div className="container">
      <div className="footer-row row pb-5">
        <div className="col-sm-12 col-lg-4 d-flex justify-content-center justify-content-lg-start p-0">
          <img
            src={logoBlue}
            className="logo"
            alt="Our Logo"
          />
        </div>
        <div className="footer-page-links d-flex justify-content-lg-center col-sm-12 col-md-6 col-lg-4 mt-md-5 mt-lg-3">
          <ul className="ps-0">
            {/* <ListLinkNoPrefetch to="/our-clients/dental-practices">
              Our Clients
            </ListLinkNoPrefetch> */}
            {/* <ListLink to="/marketing-solutions">Patient Acquisition</ListLink>
            <ListLink to="/px-patient-experience">Patient Experience (PX)</ListLink>
            <ListLink to="/portal-dashboard">Practice Analytics</ListLink>
            <ListLink to="/plans">Plans</ListLink>
            <ListLink to="/blog">Blog</ListLink>
            <ListLinkNoPrefetch to="/contact">Contact</ListLinkNoPrefetch>
            <ListLink to="/sitemap">Sitemap</ListLink> */}
            <li><a href="/marketing-solutions">Patient Acquisition</a></li>
            <li><a href="/px-patient-experience">Patient Experience (PX)</a></li>
            <li><Link to="/portal-dashboard">Practice Analytics</Link></li>
            <li><a href="/plans">Plans</a></li>
            <li><a href="/blog">Blog</a></li>
            <li><a href="/resources/case-studies">Case Studies</a></li>
            <li><a href="https://portal.doctorgenius.com/login" target="_blank" rel="noreferrer">Portal Login</a></li>
            <li><a href="/sitemap">Sitemap</a></li>
            <li><a href="/resources-site-map">Resources Site Map</a></li>

          </ul>
        </div>
        <div className="col-10 col-sm-10 col-md-6 col-lg-4 mt-md-5 mt-lg-3 d-flex flex-column justify-content-start ps-sm-5">
          <div className="d-flex footer-contact-row d-flex justify-content-start mb-5">
            <div className="footer-icon-wrapper">
              <img
                className="img-icon"
                src={ringingPhoneIcon}
                alt="Phone Icon"
              />
            </div>
            <p
              className="footer-contact-details">
              <a href = "tel:877-477-2311">&#40;877&#41; 477-2311</a>
            </p>
          </div>
          <div className="d-flex footer-contact-row d-flex justify-content-start mb-5">
            <div className="footer-icon-wrapper">   
              <img
                className="img-icon"
                src={envelopeIcon}
                alt="Envelope Icon"
              />
            </div>
            <p
              className="footer-contact-details">
              support@doctorgenius.com
            </p>
          </div>
          <div className="d-flex footer-contact-row d-flex justify-content-start mb-3">
            <div className="footer-icon-wrapper">
              <img
                className="img-icon"
                src={mapPin}
                alt="Map Icon"
              />
            </div>
            <address
              className="footer-contact-details"
            >16800 Aston St Suite 270<br/>Irvine, CA 92606
              {/* {dgAddress.street} <br />
              {dgAddress.city}, {dgAddress.state} {dgAddress.zipCode} */}
            </address>
          </div>
          <div className="social-media-row">
            <div className="social-media-item">
              <a href="https://www.facebook.com/DoctorGeniusMarketing">
                <img src={facebookIcon} alt="Facebook Icon" />
              </a>
            </div>
            <div className="social-media-item">
              <a href="https://twitter.com/DoctorGeniusCA">
                <img src={twitterIcon} alt="Twitter Icon" />
              </a>
            </div>
            <div className="social-media-item">
              <a href="https://www.instagram.com/doctor.genius/">
                <img src={instagramIcon} alt="Instagram Icon" />
              </a>
            </div>
            <div className="social-media-item">
              <a href="https://www.linkedin.com/company/doctor-genius">
                <img src={linkedinIcon} alt="LinkedIn Icon" />
              </a>
            </div>
            {/* <div
              className={FooterStyles.socialMediaItem + " social-media-item"}
            >
              <a href="https://www.youtube.com">
                <img src={youtubeIcon} alt="Youtube Icon" />
              </a>
            </div> */}
          </div>
        </div>
      </div>
      <div className="row" style={{paddingTop: '2rem'}}>
        <div className="col-sm-12">
          <div className="footer-sub-row">
            <div className="copyright-section">
              &copy;{new Date().getFullYear()} Doctor Genius. All Rights
              Reserved.
            </div>
            <div className="legal-links">
              {/* todo: how can we get ListLink to accept BS classes */}
              {/* <ListLink className="pe-3" to="/privacy-policy">Privacy Policy</ListLink>
              <ListLink className="ps-3" to="/termsofservice">Terms of Service</ListLink> */}
              <li className="pe-3"><a href="/privacy-policy">Privacy Policy</a></li>
              <li className="ps-3"><a href="/termsofservice">Terms of Service</a></li>
              {/* Waiting for page content before we show this link */}
              {/*<span> | </span>
              <ListLink to="/">Terms and Conditions</ListLink>*/}
            </div>
          </div>
        </div>
      </div>
      {children}
    </div>
  </footer>
)

export default Footer;
